import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app">
          <LandingPage />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;